import MapPage from "../views/Map/MapPage";
import Map from "@material-ui/icons/Map";

export const mapRoutes = [
  {
    collapse: true,
    name: "Seguimiento",
    icon: Map,
    state: "pageCollapse",
    inSidebar: true,
    isProtected: true,
    rule: "MAP",
    views: [
      {
        path: "/mapa_seguimiento",
        name: "Mapa",
        mini: "Map",
        component: MapPage,
        layout: "/maps",
        inSidebar: true,
        isProtected: true,
        rule: "MAP",
      },
    ],
  },
]